var exports = {
  "UD": "ApplicationsTab.module__buttonContainer___c1lpej",
  "v$": "ApplicationsTab.module__documentationLink___c1lpej",
  "Qp": "ApplicationsTab.module__documentationIcon___c1lpej",
  "qI": "ApplicationsTab.module__listContainer___c1lpej",
  "DB": "ApplicationsTab.module__itemContainer___c1lpej",
  "k0": "ApplicationsTab.module__itemButton___c1lpej",
  "HS": "ApplicationsTab.module__itemLeft___c1lpej",
  "vi": "ApplicationsTab.module__itemAvatar___c1lpej",
  "KO": "ApplicationsTab.module__itemAvatarPlaceholder___c1lpej",
  "c2": "ApplicationsTab.module__itemTextBlock___c1lpej",
  "wH": "ApplicationsTab.module__itemTitleRow___c1lpej",
  "TJ": "ApplicationsTab.module__itemName___c1lpej",
  "YD": "ApplicationsTab.module__itemMetaRow___c1lpej",
  "v5": "ApplicationsTab.module__itemChevron___c1lpej",
  "p$": "ApplicationsTab.module__emptyState___c1lpej",
  "dc": "ApplicationsTab.module__spinnerContainer___c1lpej",
};

module.exports = exports;
